export function getRandomColor() {
    const randomColor = {
      r: Math.floor(Math.random() * 256),
      g: Math.floor(Math.random() * 256),
      b: Math.floor(Math.random() * 256),
      a: 0.8 //Math.random().toFixed(2), // Random alpha value between 0 and 1 with two decimal places
    };
  
    return `rgba(${randomColor.r}, ${randomColor.g}, ${randomColor.b}, ${randomColor.a})`;
  }